var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "input-radio-select",
    class: {
      'input-radio-select--vertical': _vm.isVertical
    }
  }, [_vm.icon ? _c('div', {
    staticClass: "input-radio-select__icon"
  }, [_c('fa', {
    attrs: {
      "icon": _vm.icon,
      "fixed-width": ""
    }
  })], 1) : _vm._e(), _vm.label ? _c('div', {
    staticClass: "input-radio-select__label"
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]) : _vm._e(), _c('div', {
    staticClass: "input-radio-select__buttons"
  }, _vm._l(_vm.selections, function (selection) {
    return _c('div', {
      key: selection.value,
      staticClass: "input-radio-select__button touch",
      class: {
        'input-radio-select__button--active': _vm.selected.includes(selection.value)
      },
      on: {
        "click": function click($event) {
          return _vm.handleSelection(selection.value);
        }
      }
    }, [_vm._v("\n      " + _vm._s(selection.label[_vm.language.code]) + "\n    ")]);
  }), 0)]);

}
var staticRenderFns = []

export { render, staticRenderFns }